import { Link } from "react-router-dom";

const footerLinks = {
  content: [
    { label: "日韩剧集", to: "/category/drama" },
    { label: "日韩电影", to: "/category/movie" },
    { label: "动漫番剧", to: "/category/anime" },
    { label: "综艺娱乐", to: "/category/variety" },
    { label: "音乐现场", to: "/category/music" },
    { label: "纪录片", to: "/category/documentary" },
  ],
  about: [
    { label: "关于我们", to: "/about" },
    { label: "品牌故事", to: "/about" },
    { label: "用户口碑", to: "/about" },
    { label: "联系我们", to: "/about" },
  ],
  support: [
    { label: "常见问题", to: "/" },
    { label: "观看指南", to: "/" },
    { label: "版权声明", to: "/" },
    { label: "隐私政策", to: "/" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                aaa<span className="text-primary-500">日韩</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              aaa日韩官方正版授权平台，汇聚海量日韩优质内容资源。高清流畅、多端同步、每日更新，为您带来极致的日韩内容观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">内容分类</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">关于平台</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">帮助支持</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500">
              客服邮箱：support@aaark.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 aaa日韩 版权所有 | 正版授权内容平台
          </p>
          <p className="text-xs text-foreground-500">
            本站所有内容均已获得正版授权，侵权必究
          </p>
        </div>
      </div>
    </footer>
  );
}